import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Layout from './components/Layout/Layout';
import Home from './pages/Home';
import GenerateInvoice from './pages/GenerateInvoice';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import LegalPages from './pages/LegalPages';
import Login from './pages/Auth/Login';
import Signup from './pages/Auth/Signup';
import Subscription from './pages/Subscription';
import SubscriptionSuccess from './pages/SubscriptionSuccess';
import TemplateSuccess from './pages/TemplateSuccess';
import Contact from './pages/Contact';

function App() {
  return (
    <Router>
      <div className="App">
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
          }}
        />
        
        <Routes>
          {/* Auth routes without layout */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/template-success" element={<TemplateSuccess />} />
          
          {/* Main app routes with layout */}
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="generate-invoice" element={<GenerateInvoice />} />
            <Route path="blog" element={<Blog />} />
            <Route path="blog/:slug" element={<BlogPost />} />
            <Route path="subscription" element={<Subscription />} />
            <Route path="subscription/success" element={<SubscriptionSuccess />} />
            <Route path="contact" element={<Contact />} />
            
            {/* Legal Pages */}
            <Route path="privacy-policy" element={<LegalPages />} />
            <Route path="terms-of-use" element={<LegalPages />} />
            <Route path="cookies" element={<LegalPages />} />
            <Route path="security" element={<LegalPages />} />
            
            {/* Placeholder pages for SEO structure */}
            <Route path="about" element={<PlaceholderPage title="About Us" />} />
            <Route path="pro-plan" element={<PlaceholderPage title="Pro Plan" />} />
            <Route path="how-it-works" element={<PlaceholderPage title="How It Works" />} />
            <Route path="faq" element={<PlaceholderPage title="FAQ" />} />
            <Route path="support" element={<PlaceholderPage title="Technical Support" />} />
            <Route path="cancellation-refund" element={<PlaceholderPage title="Cancellation & Refund" />} />
            <Route path="advertising-policy" element={<PlaceholderPage title="Advertising Policy" />} />
            <Route path="api" element={<PlaceholderPage title="API for Developers" />} />
            <Route path="sitemap" element={<PlaceholderPage title="Sitemap" />} />
            <Route path="mobile-app" element={<PlaceholderPage title="Mobile App" />} />
            <Route path="invoice-examples" element={<PlaceholderPage title="Invoice Examples" />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

// Placeholder component for pages not yet implemented
const PlaceholderPage: React.FC<{ title: string }> = ({ title }) => (
  <div className="min-h-screen bg-gray-50 flex items-center justify-center">
    <div className="text-center">
      <h1 className="text-3xl font-bold text-gray-900 mb-4">{title}</h1>
      <p className="text-gray-600">This page is coming soon!</p>
    </div>
  </div>
);

export default App;